import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpWithBg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 16,
		rx: 2,
		fill: "#E7EEFF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.66705 12.5251V5.07847L11.9204 8.3318C12.1804 8.5918 12.6071 8.5918 12.8671 8.3318C13.1271 8.0718 13.1271 7.6518 12.8671 7.3918L8.47372 2.99847C8.21372 2.73847 7.79372 2.73847 7.53372 2.99847L3.13372 7.38513C2.87372 7.64513 2.87372 8.06513 3.13372 8.32513C3.39372 8.58513 3.81372 8.58513 4.07372 8.32513L7.33372 5.07847V12.5251C7.33372 12.8918 7.63372 13.1918 8.00039 13.1918C8.36705 13.1918 8.66705 12.8918 8.66705 12.5251Z",
		fill: "#3C59F6"
	})]
});
export default SvgArrowUpWithBg;
